var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedBlueIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C19.1274 25 24.5 19.6274 24.5 13C24.5 6.37258 19.1274 1 12.5 1C5.87258 1 0.5 6.37258 0.5 13C0.5 19.6274 5.87258 25 12.5 25Z",
    fill: "#9EB3F8",
    stroke: "#5E81F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08972 13.0189C7.00452 12.9349 6.96191 12.8089 6.96191 12.7249C6.96191 12.6409 7.00452 12.5149 7.08972 12.4309L7.68617 11.8429C7.85659 11.6749 8.11221 11.6749 8.28262 11.8429L8.32523 11.8849L10.6684 14.3629C10.7536 14.4469 10.8814 14.4469 10.9666 14.3629L16.6755 8.52493H16.7181C16.8885 8.35693 17.1442 8.35693 17.3146 8.52493L17.911 9.11293C18.0814 9.28093 18.0814 9.53293 17.911 9.70093L11.0945 16.6729C11.0093 16.7569 10.924 16.7989 10.7962 16.7989C10.6684 16.7989 10.5832 16.7569 10.498 16.6729L7.17493 13.1449L7.08972 13.0189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlueIconCircle);
export default __webpack_public_path__ + "static/media/CheckedBlueIconCircle.f65afc6b8f3f86a87d41e3a3ff348099.svg";
export { ForwardRef as ReactComponent };